

<div #widgetContainer class="turnstile-widget" [class.turnstile-widget--floating]="invisibleUntilSubmit"></div>
